import $ from "jquery";

$(document).ready(function () {
    $(document).on('click', '.loadAjaxModal', function () {
        if ($('#ajaxModal').data('bs.modal').isShown) {
            $('#ajaxModal').find('#ajaxModalBody').load($(this).attr('value'));
        } else {
            $('#ajaxModal').modal('show')
                .find('#ajaxModalBody')
                .load($(this).attr('value'));
        }
    });
});